export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");

        function closePopup() {
            $(".popup").removeClass("active").find(".bio-popup-info").removeClass("content-updated");
            mainWrap.removeClass("popup-open");

        }

        $(document).on("click", ".popup-opener", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $target = $this.attr("href");

            $($target).addClass("active").fadeIn(300);
            mainWrap.addClass("popup-open");

        }).on("click", ".popup-close, .back-link", function (e) {
            e.preventDefault();
            closePopup.call(this);
        });


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js